import { all, call, fork, put, takeEvery } from "redux-saga/effects";
// Include call API
import { getWarningsAPI } from "../../../api/warnings";
import { getWarningsError, getWarningsSuccess } from "./actions";
// Login Redux States
import { GET_WARNINGS } from "./actionTypes";



const warningsAPI = getWarningsAPI();

function* getWarningsFetch({ payload: { user, history } }) {
  try {
    const response = yield call(warningsAPI.getWarnings, user.token);
    console.log("WARNINGS",response)
    yield put(getWarningsSuccess(response.warnings, response.message));
  } catch (error) {
    yield put(getWarningsError(error));
  }
}

export function* watchGetWarnings() {
  yield takeEvery(GET_WARNINGS, getWarningsFetch);
}

function* getWarningsSaga() {
  yield all([fork(watchGetWarnings)]);
}

export default getWarningsSaga;
